import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers/RootReducer';
import { SPIN_WHEELS } from '../../constant/spinWheels';
import classes from './SpinWheel.module.css';

interface SpinWheelProps {
  rotation: number;
  spinning: boolean;
  spinMs: number;
  size?: number;
}

const SpinWheel: FC<SpinWheelProps> = ({ rotation, spinning, spinMs, size = 540 }) => {
  const markerSize = Math.round(size * (50 / 500));
  // Shared choice, so every page in the journey shows the same face
  const wheelIndex = useSelector((state: RootState) => state.spinToWin.wheelIndex);
  const face = SPIN_WHEELS[wheelIndex].image;

  return (
  <div className={classes.wheelArea} style={{ width: size, height: size }}>
    <img src="/images/mark.png" className={classes.wheelMark} style={{ width: markerSize }} alt="" draggable={false} />
    <img src="/images/spin-wheel-outer.png" className={classes.wheelOuter} alt="" draggable={false} />

    <div
      className={classes.wheelWrapper}
      style={{
        transform:  `rotate(${rotation}deg)`,
        transition: spinning
          ? `transform ${spinMs}ms cubic-bezier(0.12, 0.8, 0.4, 1)`
          : 'none',
      }}
    >
      <img src={face} alt="Spin wheel" className={classes.wheelImg} draggable={false} />
    </div>

    <img src="/images/spin-wheel-center.png" className={classes.wheelCenter} alt="" draggable={false} />
  </div>
  );
};

export default SpinWheel;
